module.exports = (haystack, needle) => haystack.includes(needle)
